<template>
  <div class="non-printable">
    <div class="b-step-nav">
      <button v-if="showBack" type="button" class="btn btn-secondary" @click="$emit('back')">
        Bakåt
      </button>

      <button
        type="button"
        class="btn btn-primary btn-spacer"
        :disabled="!canAdvance"
        @click="$emit('next')"
      >
        {{ nextLabel }}
      </button>
    </div>

    <p v-if="!canAdvance && blockedReason" class="b-step-nav-note">
      {{ blockedReason }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'StepNav',
  props: {
    showBack: { type: Boolean, default: true },
    canAdvance: { type: Boolean, default: true },
    nextLabel: { type: String, default: 'Nästa' },
    blockedReason: { type: String, default: '' },
  },
  emits: ['back', 'next'],
}
</script>
